import Banner, { BannerElement } from "@/components/Banner/Banner";
import { useGetDebtorEditViewApiDataQuery } from "@/services/debtors/debtorsReducers";
import { useParams } from "react-router-dom";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ActiveTabsOrder } from "@/menuData";
function DebtorSummaryHeader() {
  const { debtorId, caseId } = useParams();
  const { data, error, isLoading } = useGetDebtorEditViewApiDataQuery(debtorId);
  const getCaseDetails = useSelector(
    (state: any) => state.caseDetails?.caseData
  );
  const {t}=useTranslation();
  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: getCaseDetails?.caseName,
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.DEBTOR}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: data?.name ? data?.name : "",
      url: "/",
      disabled: true,
    },
  ];
  if (isLoading) return <div>{t("global.globalNotifications.loadingMessage")}</div>;

  if (error) return <div>{t("global.globalNotifications.wentWrong")}</div>;

  const bannerElements: BannerElement[] = [
    {
      label: "Debtor ID",
      value: `${debtorId}`,
    },
    {
      label: "Distribution Status",
      value: ``,
    },
    {
      label: "Total Claims",
      value: `${data?.totalClaims}`,
    },
  ];

  return (
    <>
      <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
      <Banner
        bannerName="Debtor"
        bannerNameValue={data?.name}
        elements={bannerElements}
      />
    </>
  );
}

export default DebtorSummaryHeader;
